// Package Imports
import { Route } from 'react-router-dom';
import React, { lazy, Suspense } from 'react';
// Project Imports
import routeName from 'core/common/routeName';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import PrivateRoute from 'core/utils/PrivateRoute';
import Loading from 'components/loading/loading';

const Holiday = lazy(() => import('pages/holiday/holiday'));

const HolidayRoute = (
  <Route path={routeName.holiday}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.HOLIDAY_VIEW}>
          <Suspense fallback={<Loading />}>
            <Holiday />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default HolidayRoute;
